import { styled } from "@mui/material/styles";
import { Grid } from "@mui/material";

export const Container = styled(Grid)(({ theme }) => ({
  height: "400px",
  width: "100%",
  backgroundColor: theme.palette.background.default,

  ".MuiDataGrid-cell--withRenderer.MuiDataGrid-cell": {
    overflow: "visible",
  },
}));
